module.exports = __webpack_public_path__ + "img/empty.660ff4b5.svg";